import { z } from 'zod';

export const YearMonthSchema = z.object({
  year: z.number().int().describe('연도'),
  month: z.number().int().describe('월'),
  displayText: z.string().describe('표시 텍스트 (YYYY.MM)'),
});

export const GetAvailableMonthsServiceDTOSchema = z.array(YearMonthSchema);

export type GetAvailableMonthsServiceDTO = z.infer<typeof GetAvailableMonthsServiceDTOSchema>;
